import { IonButton } from '@ionic/react';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { CommentPlusSVGIcon } from '../theme/Icons';
import { useIfLoggedIn } from '../utils/useIfLoggedIn';

const useStyles = createUseStyles({
    btn: {
        gap: 6,
        display: 'flex',
        alignItems: 'center'
    },

    icon: {
        width: 24,
        height: 24,

        '& svg': {
            fill: 'var(--ion-color-step-750)'
        }
    }
});

export type IAddCommentButton = {
    onClick: () => void;
    authenticatedRedirect: string;
};

export const AddCommentButton: FC<IAddCommentButton> = ({ onClick, authenticatedRedirect }) => {
    const classes = useStyles();

    const ifLoggedIn = useIfLoggedIn();

    const clickHandler = async () => {
        ifLoggedIn({
            delegate: onClick,
            redirect: authenticatedRedirect,
            message: 'Please sign in or create an account to add comments.',
            trackingFrom: 'Comments'
        });
    };

    return (
        <IonButton
            size="small"
            shape="round"
            color="light"
            onClick={clickHandler}
            style={{'--box-shadow': 'none'}}
            data-type={'add-comment-btn'}
        >
            <div className={classes.btn}>
                <div className={classes.icon}>
                    {CommentPlusSVGIcon}
                </div>
            </div>
        </IonButton>
    );
};
